var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 15.429 12",
    width: 15.429,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.823 11.749a.857.857 0 0 1 0-1.212l3.68-3.68h-11.646a.857.857 0 1 1 0-1.714h11.643l-3.68-3.68a.857.857 0 0 1 1.215-1.212l5.143 5.143a.857.857 0 0 1 .147.2l.009.017.006.012v.017l.007.015a.859.859 0 0 1 -.008.7l-.006.013v.017l-.006.011v.007l-.007.013-.008.014-.009.015-.01.015-.01.015-.01.014-.009.012v.005l-.008.01-.008.009-.005.006-.013.015-.035.036-5.139 5.139a.857.857 0 0 1 -1.212 0z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b0c94b9a18646c91ceff5374ae8e8e8e.svg";
export { ForwardRef as ReactComponent };